import React from 'react';
import { Utensils } from 'lucide-react';

const Footer = ({ setCurrentPage }) => {
  const navigation = [
    { name: 'Home', id: 'home' },
    { name: 'Products & Services', id: 'products' },
    { name: 'Support', id: 'support' }
  ];

  return (
    <footer style={{
      backgroundColor: '#1f2937',
      color: 'white',
      padding: '60px 0 40px'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              <Utensils size={24} color="#9ca3af" style={{ marginRight: '10px' }} />
              <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Krafty Restaurants</span>
            </div>
            <p style={{ color: '#9ca3af' }}>Building the future of restaurant technology</p>
          </div>
          <div>
            <h3 style={{ marginBottom: '20px' }}>Quick Links</h3>
            {navigation.map((item) => (
              <button
                key={item.id}
                onClick={() => setCurrentPage(item.id)}
                style={{
                  display: 'block',
                  background: 'none',
                  border: 'none',
                  color: '#9ca3af',
                  cursor: 'pointer',
                  padding: '5px 0',
                  textAlign: 'left'
                }}
              >
                {item.name}
              </button>
            ))}
          </div>
          <div>
            <h3 style={{ marginBottom: '20px' }}>Contact</h3>
            <p style={{ color: '#9ca3af', marginBottom: '10px' }}>1-800-KRAFTY-1</p>
            <p style={{ color: '#9ca3af', marginBottom: '10px' }}>support@kraftyrestaurants.com</p>
            <p style={{ color: '#9ca3af' }}>San Francisco, CA</p>
          </div>
          <div>
            <h3 style={{ marginBottom: '20px' }}>Follow Us</h3>
            <div style={{ display: 'flex', gap: '15px' }}>
              {['f', 't', 'in'].map((social, idx) => (
                <div
                  key={idx}
                  style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: '#7c3aed',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  <span>{social}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{
          borderTop: '1px solid #374151',
          marginTop: '40px',
          paddingTop: '40px',
          textAlign: 'center'
        }}>
          <p style={{ color: '#9ca3af' }}>&copy; 2025 Krafty Restaurants. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;